import React, {Component} from 'react';
import parse from 'html-react-parser';

export default class Overlay extends Component {

    render() {
        const closeCb = this.props.closeCb;
        const display = this.props.display;
        const overlayText = this.props.text ? this.props.text : "";

        if(!display) {
            return null;
        }

        return (
            <div className="overlay" onClick={closeCb}>
                <div className="modal" id="agreement" onClick={(e) => e.stopPropagation()}>
                    <div className="modal__close" onClick={closeCb}>&times;</div>
                    <div className="modal__subtitle">
                        {parse(overlayText)}
                    </div>
                </div>
            </div>
        )
    }
}
